import * as angular from 'angular';
import { NotificationsComponent } from './notifications.component';

export const NotificationsModule = angular
  .module('notificationsModule', [])
  .component('notifications', NotificationsComponent).name;
